var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import { connect } from "@irati/store";
import { Label1 } from "@irati/ui/src/Labels";
import { FormattedCurrency, FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import StatusType from "@irati/wallet/types/enums/Status";
import { Container, Img, ImgWrapper, Description, Fiscal, Amount, Status, SubTitle } from "./styled";
var getAmountElement = function (amount, currency, status) {
    var formattedCurrency = React.createElement(FormattedCurrency, { isCents: false, value: amount, currency: currency });
    switch (status) {
        case StatusType.PENDING:
            return React.createElement(Amount, { pending: true },
                "+ ",
                formattedCurrency);
        case StatusType.CANCELLED:
            return React.createElement(Amount, { cancelled: true }, formattedCurrency);
        case StatusType.FAILED:
            return React.createElement(Amount, { failed: true }, formattedCurrency);
        case StatusType.SPENT:
            return React.createElement(Amount, { spent: true },
                "- ",
                formattedCurrency);
        case StatusType.CLEARED:
            return React.createElement(Amount, { cleared: true },
                "+ ",
                formattedCurrency);
        default:
            return null;
    }
};
var getStatusElement = function (status) {
    switch (status) {
        case StatusType.PENDING:
            return (React.createElement(Status, { pending: true },
                React.createElement(FormattedMessage, { id: "wallet.primaryDetails.status.pending" })));
        case StatusType.CANCELLED:
            return (React.createElement(Status, { cancelled: true },
                React.createElement(FormattedMessage, { id: "wallet.primaryDetails.status.cancelled" })));
        case StatusType.FAILED:
            return (React.createElement(Status, { failed: true },
                React.createElement(FormattedMessage, { id: "wallet.primaryDetails.status.failed" })));
        case StatusType.SPENT:
            return (React.createElement(Status, { spent: true },
                React.createElement(FormattedMessage, { id: "wallet.primaryDetails.status.spent" })));
        case StatusType.CLEARED:
            return (React.createElement(Status, null,
                React.createElement(FormattedMessage, { id: "wallet.primaryDetails.status.cleared" })));
        default:
            return null;
    }
};
var PrimaryDetails = /** @class */ (function (_super) {
    __extends(PrimaryDetails, _super);
    function PrimaryDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrimaryDetails.prototype.render = function () {
        var _a = this.props, className = _a.className, isPhone = _a.isPhone, data = _a.data, imgHeightAuto = _a.imgHeightAuto;
        var image = data.image, title = data.title, subTitle = data.subTitle, savingsTitle = data.savingsTitle, amount = data.amount, currency = data.currency, status = data.status, ProfilePicture = data.ProfilePicture;
        var idNamespace = id("primary-details", this.props);
        return (React.createElement(Container, { className: className, id: idNamespace, alignItems: "center" },
            !isPhone && (React.createElement(ImgWrapper, { alignItems: "center" }, ProfilePicture || React.createElement(Img, { autoHeight: imgHeightAuto, src: image, alt: title }))),
            React.createElement(Description, null,
                React.createElement(Label1, null, title),
                React.createElement(SubTitle, null, subTitle),
                savingsTitle && React.createElement(SubTitle, null, savingsTitle)),
            React.createElement(Fiscal, null,
                getAmountElement(amount, currency, status),
                getStatusElement(status))));
    };
    PrimaryDetails.defaultProps = {
        className: null,
        imgHeightAuto: false
    };
    return PrimaryDetails;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isPhone: get(mq, "lessThan.medium", false)
    });
};
export default connect(mapStateToProps)(PrimaryDetails);
